import React from 'react';

import { Footer, Blog, Possibility, Features, Services, Header } from './containers';
import { CTA, Brand, Navbar, Partner } from './components';

import './App.css';

const App = () => (
  <div className="App">
    <div className="gradient__bg">
      <Navbar />
      <Header />
    </div>
    <Partner />
    <Brand />
    <Services />
    <Features />
    <Possibility />
    <CTA />
    <Blog />
    <Footer />
  </div>
);

export default App;
